/**
 * Swaps a sales point's wording when a given variant option is selected.
 *
 * Sales points are static theme blocks, so their copy cannot vary per variant server-side. Both
 * strings are rendered by product-template.liquid and this flips which one is visible, keyed off
 * the exact option value the merchant typed into the block (e.g. "Tough Case").
 */
(function () {
  function apply(variant) {
    if (!variant || !variant.options) return;
    document.querySelectorAll('[data-sales-point-swap]').forEach(function (el) {
      var altValue = el.dataset.altValue;
      var useAlt = variant.options.indexOf(altValue) !== -1;
      var main = el.querySelector('[data-sales-point-text]');
      var alt = el.querySelector('[data-sales-point-text-alt]');
      if (main) main.hidden = useAlt;
      if (alt) alt.hidden = !useAlt;
    });
  }

  document.addEventListener('variant:change', function (evt) {
    apply(evt.detail && evt.detail.variant);
  });
})();
